module.exports = __webpack_public_path__ + "static/media/star2_lightgrey.826caadb.png";